<template>
  <div>
    <template v-if="info !== null">
      <b-row>
        <b-col class="text-center my-4">
          <h3 class="font-weight-bold d-inline">{{ info.name }}
            <sup class="text-warning">
              <span v-for="star in info.class" :key="star">
                <b-icon icon="star-fill" />
              </span>
            </sup>
          </h3>
          <h6 class="d-inline ml-2 text-info">{{info.extraClass}}</h6>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" class="noPrint">
          <b-row>
            <b-col sm="6">
              <h6><b v-translate>Gallery</b></h6>
              <div class="carousel-wrapper">
                <!-- <img :src="info.images[0].url" class="print-only" style="height:250px;" /> -->
                <b-card no-body >
                  <b-carousel
                    id="carousel"
                    controls
                    indicators
                    v-if="info.images.length">
                    <b-carousel-slide v-for="(image,imageIndex) in info.images" :key="imageIndex">
                      <template slot="img">
                        <img :src="image.url" class="img-fluid w-100 d-block"/>
                      </template>
                    </b-carousel-slide>
                  </b-carousel>
                  <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
                   <b-card-footer class="bg-light" v-if="info.files.length">
                    <h6 class="modal-title border-bottom mb-2" v-translate>Attached files</h6>
                    <b-list-group v-for="(file, fileIndex) in info.files" :key="'file' + fileIndex" flush>
                      <b-list-group-item target="_self" :href="file.url" class="py-1 pl-1 bg-light">
                        <b-icon icon="file-earmark-text" scale="1.3" class="mr-1 text-danger"/>
                        <b>{{ file.label }}</b>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card-footer>
                </b-card>
              </div>
            </b-col>
            <b-col sm="6" v-if="mapUrl">
              <h6><b v-translate>Location</b></h6>
              <div class="noPrint">
                <GmapMap
                  :center="{lat: info.latitude, lng: info.longitude }"
                  :zoom="16"
                  style="width: 500px; height: 250px"
                >
                  <GmapMarker
                    :position="{lat: info.latitude, lng: info.longitude }"
                    :label="{ text: 'H', color: 'blue' }"
                  />
                </GmapMap>
              </div>
              <!-- <img :src="mapUrl" class="img-fluid map" v-show="false" /> -->
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" class="print-only">
          <table>
            <tbody>
              <tr>
                <td class="w-50 px-2"><img :src="info.images[0].url" class="img-fluid" v-if="info.images.length"/></td>
                <td class=""><img :src="mapUrl" class="img-fluid"/></td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row class="my-3" v-if="info.description || info.url || info.descriptions.length">
        <b-col sm="12">
          <h5 class="modal-title my-2 pb-2 border-bottom"><b v-translate>Description</b> <b-button @click="seeMore" variant="outline-primary" size="sm" class="ml-3">{{button.text}}</b-button></h5>
          <div class="mt-2" v-show="moreInfo">
            <p style="text-align:justify;" class="mb-0" v-if="info.descriptionIsHtml" v-html="info.description"></p>
            <p style="text-align:justify; white-space: pre-line;" class="mb-0" v-else>{{ info.description }}</p>
          <div v-for="(desc, descIndex) in info.descriptions" :key="'desc' + descIndex">
            <h6 class="modal-title">{{ desc.label }}</h6>
            <p v-html="desc.text"></p>
          </div>
          </div>
        </b-col>
        <b-col>
          <small v-if="info.url">
            <a :href="info.url" target="_blank">{{ info.url }}</a>
          </small>
        </b-col>
      </b-row>
    </template>
    <b-row v-else>
      <b-col md="12" class="text-center pt-3">
        <b-aspect aspect="10">
          <b-spinner type="grow" label="Se incarca"></b-spinner>
          <p v-translate>Please wait...</p>
        </b-aspect>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
  .print-only {
    display: none!important;
  }
</style>

<script>
import { getHotelInfo } from 'b2b-common/services/api/hotel'

export default {
  name: 'HotelInfo',
  props: ['result'],
  data () {
    return {
      info: null,
      moreInfo: false,
      map: null,
      button: {
        text: 'show more'
      }
    }
  },
  async created () {
    const info = await getHotelInfo({ hotelId: this.result.id })
    if (info.length) {
      this.info = {}
      for (const key in info[0]) {
        this.$set(this.info, key, info[0][key])
      }
    }
  },
  methods: {
    seeMore () {
      this.moreInfo = !this.moreInfo
      this.button.text = this.moreInfo ? this.$gettext('show less') : this.$gettext('show more')
    }
  },
  computed: {
    mapUrl () {
      if (this.info.latitude === null || this.info.longitude === null) return null
      return 'https://maps.googleapis.com/maps/api/staticmap?zoom=16&size=600x300&sensor=false&key=AIzaSyB2ESGH-2mD52_8nTqxQEz6djeShdcDOZE' +
         '&center=' + this.info.latitude + ',' + this.info.longitude +
        '&markers=color:blue%7Clabel:H%7C' + this.info.latitude + ',' + this.info.longitude
    }
  }
}
</script>
